module.exports = __webpack_public_path__ + "img/bg_pad.660e7b58.png";